import React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Alert,
    Typography,
} from '@mui/material';
import { useTranslation } from 'react-i18next';

const RotateSecretDialog = ({ open, onClose, onConfirm, isRotating }) => {
    const { i18n } = useTranslation();
    const isArabic = (i18n.language || 'en').startsWith('ar');

    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
            <DialogTitle sx={{ fontWeight: 700 }}>
                {isArabic ? 'تدوير السر' : 'Rotate secret'}
            </DialogTitle>
            <DialogContent dividers>
                <Alert severity="warning" sx={{ mb: 2 }}>
                    {isArabic
                        ? 'سيتوقف السر القديم فوراً وستفشل أي طلبات قادمة لم تُحدّث للسر الجديد.'
                        : 'The old secret stops working immediately. Any consumer not updated to the new secret will start rejecting deliveries.'}
                </Alert>
                <Typography variant="body2">
                    {isArabic
                        ? 'هل أنت متأكد من المتابعة؟'
                        : 'Are you sure you want to continue?'}
                </Typography>
            </DialogContent>
            <DialogActions sx={{ px: 3, py: 2 }}>
                <Button onClick={onClose} disabled={isRotating}>
                    {isArabic ? 'إلغاء' : 'Cancel'}
                </Button>
                <Button
                    color="warning"
                    variant="contained"
                    onClick={onConfirm}
                    disabled={isRotating}
                >
                    {isRotating
                        ? (isArabic ? 'جاري...' : 'Working...')
                        : (isArabic ? 'تدوير' : 'Rotate')}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default RotateSecretDialog;
